import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { UUID } from 'angular2-uuid';
import { HttpClientModule, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import axios from 'axios';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class ClaveUnicaService {
    public url;
    public bodyData = {
        "clientId": environment.clientId,
        "clientSecret": environment.clientSecret,
        "redirectUrl": "https://muniptealto-develop.solnet.cl",
        "endpoint": "https://accounts.claveunica.gob.cl"
    }
    public api = 'https://lnxaz02.solnet.cl:3020'

    constructor(
        private _http: HttpClient,
        private cookieService: CookieService
    ) {
    }

    getToken(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json'
        });

        let body = this.bodyData;

        // Realizar la solicitud POST enviando el body
        return this._http.post(this.api + `/clave-unica/generate-url`, body, { headers: headers })
            .pipe(map((response: any) => response)); // Procesar la respuesta
    }

    getInfoCiudadano(code, state): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json'
        });

        // Definir los parámetros
        let params = new HttpParams()
            .set('code', code)
            .set('state', state);

        let body = this.bodyData;

        // Realizar la solicitud POST enviando el body
        return this._http.post(this.api + `/clave-unica/info-ciudadano`, body, { headers: headers, params: params })
            .pipe(map((response: any) => response)); // Procesar la respuesta
    }


    async logoutClaveUnica(): Promise<any> {
        window.location.href = 'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout';

       /*  const logoutUrl = 'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout'; */

        this.cookieService.delete('sessionid');
        try {
          /*   const response = await axios.get(logoutUrl);
            return response; */
        } catch (error) {
            throw error;
        }
    }

}
